import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';

@Component({
  standalone: false,
  selector: 'app-login-signup-button',
  template: `
    <fl-button
      [submit]="true"
      [busy]="busy"
      [color]="color"
      [display]="'block'"
      [disabled]="disabled"
      [flTrackingLabel]="
        stepLabel ? stepLabel + '-LoginSignupButton' : 'LoginSignupButton'
      "
      [size]="size"
      [sizeTablet]="sizeTablet"
      [sizeDesktop]="sizeDesktop"
    >
      <ng-content></ng-content>
    </fl-button>
  `,
  styleUrls: ['./login-signup-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginSignupButtonComponent {
  @Input() freelancerBranding = false;
  @Input() busy = false;
  @Input() color = ButtonColor.SECONDARY;
  @Input() disabled = false;
  @Input() size = ButtonSize.LARGE;
  @Input() sizeTablet?: ButtonSize;
  @Input() sizeDesktop?: ButtonSize;
  @Input() stepLabel = '';
}
